module.exports = __webpack_public_path__ + "static/Gotham-ThinItalic-741f4840d3af3961db777acda707ed12.woff2";